import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CSAT_MODULE_KEY } from './csat.declarations';
import { CsatPartialState } from './index';

const getFeatureState = createFeatureSelector<CsatPartialState>(
  CSAT_MODULE_KEY
);

const getCsatState = createSelector(getFeatureState, feat => feat.csat)

const getQuestions = createSelector(getCsatState, state => state.questionsList)

const getLastAnswerDate = createSelector(getCsatState, state => state.lastAnswerDate)


export const csatQuery = {
  getCsatState,
  getQuestions,
  getLastAnswerDate
}
